import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CookieService {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  setCookie(name: string, value: string, days: number) {
    if (isPlatformBrowser(this.platformId)) {
      let expirationDate: Date;

      if (days === -1) {
        expirationDate = new Date('9999-12-31T23:59:59');
      } else {
        expirationDate = new Date();
        expirationDate.setDate(expirationDate.getDate() + days);
      }

      const cookieValue = `${name}=${value}; expires=${expirationDate.toUTCString()}; path=/`;

      document.cookie = cookieValue;
    }
  }

  getCookie(name: string): string | null {
    if (isPlatformBrowser(this.platformId)) {
      const cookies = document.cookie.split(';');

      for (const cookie of cookies) {
        const [cookieName, cookieValue] = cookie.trim().split('=');

        if (cookieName === name) {
          return decodeURIComponent(cookieValue);
        }
      }
    }

    return null;
  }

  deleteCookie(name: string) {
    if (isPlatformBrowser(this.platformId)) {
      const expirationDate = new Date();
      expirationDate.setFullYear(expirationDate.getFullYear() - 1);

      const cookieValue = `${name}=; expires=${expirationDate.toUTCString()}; path=/`;

      document.cookie = cookieValue;
    }
  }
}
